"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var types_1 = require("../api/types");

exports.checkXidValid = function (xid) {
  return (xid.type === types_1.XIDItemType.UID || xid.type === types_1.XIDItemType.XC) && !!xid.value && !!Date.parse(xid.createdAt);
};